import { useUserIdWithLoading } from '@dreamstack/auth'
import { SimpleMuiButton } from '@dreamstack/feature-components/src/layout/SimpleMuiButton'
import { newsletterInputClassName } from '@dreamstack/feature-components/src/newsletter/Newsletter'
import { useLocale, useTranslation } from '@dreamstack/i18n'
import { ArrowDown } from '@dreamstack/icons/src/icon-components/ArrowDown'
import { getOrCreateAnonymousId } from '@dreamstack/tracking/src/getOrCreateAnonymousId'
import { trpc } from '@dreamstack/trpc/client'
import { cn } from '@dreamstack/util/src/cn'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'
import { scrollToTarget } from '../utils/scrollToTarget'

const Wrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(
      'bg-accentroGray-full text-white flex flex-col space-y-px-16 p-px-16 items-center',
      'md:ml-4 md:-mt-px-64 md:z-10 md:w-max md:p-px-32 md:items-end',
      className
    )}
    {...rest}
  >
    {children}
  </div>
)

export const TwoColumnLayoutContactAndNewsletterCTAs: React.FC = () => {
  const locale = useLocale()
  const { userId } = useUserIdWithLoading()
  const contactHref = locale === 'de' ? '/kontakt' : '/contact'
  const t = useTranslation()
  const { mutateAsync: trackButtonClickServer } =
    trpc.anonymousTracking.trackEvent.useMutation()
  const gotoNewsletter = () => {
    scrollToTarget(`.${newsletterInputClassName}`)
    setTimeout(() => {
      const input = document.querySelector(
        `.${newsletterInputClassName}`
      ) as HTMLInputElement
      input.focus()
    }, 500)
  }
  const router = useRouter()

  const trackMakeAppointmentClick = async () => {
    const anonymousUserId = getOrCreateAnonymousId()
    await trackButtonClickServer({
      eventName: 'buttonClick',
      userId,
      anonymousUserId,
      data: {
        buttonAction: 'Beratungsgepräch vereinbaren',
        url: router.asPath,
      },
    })
  }
  // This event only tracks the click on the newsletter button on the page, not the actual subscription
  // The actual subscription is tracked as a formSubmission Event
  const trackSubscribeToNewsletterClick = async () => {
    const anonymousUserId = getOrCreateAnonymousId()
    await trackButtonClickServer({
      eventName: 'buttonClick',
      userId,
      anonymousUserId,
      data: {
        buttonAction: 'Newsletter abonnieren',
        url: router.asPath,
      },
    })
  }

  return (
    <Wrapper>
      <Link href={contactHref} passHref className="text-accentroWhite-full">
        <SimpleMuiButton color="inherit" onClick={trackMakeAppointmentClick}>
          {t('accentro:arrangeConsultation')}
        </SimpleMuiButton>
      </Link>
      <div className="text-accentroWhite-full">
        <SimpleMuiButton
          onClick={() => {
            gotoNewsletter()
            trackSubscribeToNewsletterClick()
          }}
          variant="text"
          color="inherit"
          endIcon={
            <ArrowDown className="text-accentroWhite-full h-px-24 w-px-24 lg:h-px-48 lg:w-px-48" />
          }
        >
          {t('accentro:subscribeToNewsletter')}
        </SimpleMuiButton>
      </div>
    </Wrapper>
  )
}
